(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ba-hit-player"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const openButton = event.target.closest('[data-ba-hit-open]');
    if (openButton) {
      const card = openButton.closest('[data-ba-hit-card]');
      const dialog = card?.querySelector('dialog');
      const player = dialog?.querySelector('[data-ba-hit-player]');
      const template = card?.querySelector('[data-ba-hit-template]');
      if (!(dialog instanceof HTMLDialogElement) || !(template instanceof HTMLTemplateElement) || !player || dialog.open) return;
      dialog.addEventListener('close', () => player.replaceChildren(), { once: true });
      dialog.showModal();
      player.replaceChildren(template.content.cloneNode(true));
      return;
    }
    const closeButton = event.target.closest('[data-ba-hit-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      if (dialog instanceof HTMLDialogElement) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
